/* ============================================================
   SÁTIRO IA — "Aurora del bosque"
   Lo único que hace este archivo es decidir CUÁNDO el aura está
   encendida. Todo el aspecto vive en satiro-ia-aura.css.

   Tres estados, escritos en data-stia-aura-estado:
     dormida     -> completamente fuera de pantalla: apagada y con
                    todas las animaciones pausadas. Coste cero.
     despertando -> ~850ms de intensidad alta al entrar por primera vez.
     reposo      -> la respiración normal.

   Si este archivo no llega a cargar, el CSS deja el aura encendida
   y animada sin despertar ni pausa: se degrada, no se rompe.
   ============================================================ */
(function () {
  var ATRIBUTO = 'data-stia-aura-estado';
  var DESPERTAR_MS = 850;
  var RED_DE_SEGURIDAD_MS = 2500;

  function prefiereQuietud() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function activar(aura) {
    if (!aura || aura.getAttribute('data-stia-aura-lista') === '1') return;
    aura.setAttribute('data-stia-aura-lista', '1');

    /* Con movimiento reducido no hay nada que despertar ni que pausar:
       el CSS ya dejó una versión estática. Ni siquiera montamos el
       observer. */
    if (prefiereQuietud() || typeof IntersectionObserver === 'undefined') {
      aura.setAttribute(ATRIBUTO, 'reposo');
      return;
    }

    var yaDesperto = false;
    var temporizador = null;

    function asentar() {
      temporizador = null;
      if (aura.getAttribute(ATRIBUTO) === 'despertando') {
        aura.setAttribute(ATRIBUTO, 'reposo');
      }
    }

    function despertar() {
      if (yaDesperto) {
        if (aura.getAttribute(ATRIBUTO) === 'dormida') {
          aura.setAttribute(ATRIBUTO, 'reposo');
        }
        return;
      }
      yaDesperto = true;
      aura.setAttribute(ATRIBUTO, 'despertando');
      temporizador = window.setTimeout(asentar, DESPERTAR_MS);
    }

    function dormir() {
      if (temporizador) {
        window.clearTimeout(temporizador);
        temporizador = null;
      }
      aura.setAttribute(ATRIBUTO, 'dormida');
    }

    function mirar(entradas) {
      for (var i = 0; i < entradas.length; i++) {
        var e = entradas[i];

        /* Solo se duerme cuando NO queda nada en pantalla (umbral 0). */
        if (!e.isIntersecting) {
          dormir();
          continue;
        }

        /* Un panel más alto que el viewport nunca alcanza un ratio
           grande: con la conversación abierta puede medir varias
           pantallas y su ratio máximo quedar por debajo de 0.15.
           Para ese caso no se mira la proporción del elemento sino
           cuánta pantalla está ocupando. */
        var alto = e.boundingClientRect.height;
        var pantalla =
          (e.rootBounds && e.rootBounds.height) || window.innerHeight || 1;
        var visible = e.intersectionRect.height;
        var esAlto = alto > pantalla * 0.8;

        if (e.intersectionRatio >= 0.15 || (esAlto && visible >= pantalla * 0.25)) {
          despertar();
        }
      }
    }

    var observador = new IntersectionObserver(mirar, {
      /* Varios peldaños bajos para que un panel muy alto también
         reciba avisos antes de llegar al 15%. */
      threshold: [0, 0.05, 0.1, 0.15, 0.3]
    });

    observador.observe(aura);
    aura.stiaObservador = observador;

    /* Si por lo que sea el observer nunca dijo nada y el panel está a
       la vista, el aura enciende igual. Más vale encendida de más que
       apagada de menos. */
    window.setTimeout(function () {
      if (yaDesperto) return;
      var caja = aura.getBoundingClientRect();
      var pantalla = window.innerHeight || 0;
      if (caja.top < pantalla && caja.bottom > 0) despertar();
    }, RED_DE_SEGURIDAD_MS);
  }

  function iniciar(raiz) {
    var nodos = (raiz || document).querySelectorAll('[data-stia-aura]');
    for (var i = 0; i < nodos.length; i++) activar(nodos[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciar(document);
    });
  } else {
    iniciar(document);
  }

  /* El editor de temas monta y desmonta secciones en caliente. */
  document.addEventListener('shopify:section:load', function (e) {
    iniciar(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var nodos = e.target.querySelectorAll
      ? e.target.querySelectorAll('[data-stia-aura]')
      : [];
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].stiaObservador) nodos[i].stiaObservador.disconnect();
    }
  });
})();
